// Module
var code = "<div> <div class=\"rip-dialog-body-content\" ng-bind-html=\"message\"></div> <div class=\"rip-dialog-footer\"> <button ng-click=\"dismiss()\">{{ \"OK\" | i18n }}</button> </div> </div> ";
// Exports
module.exports = code;